import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import { useAuth } from '../../auth/AuthProvider';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access_token')}` });

const KART_TIPLERI = [
  { label: 'Personel Listesi', icon: '👥', route: '/ik#personel-listesi', color: '#1565c0' },
  { label: 'İzinler', icon: '📅', route: '/ik#izinler', color: '#ef6c00' },
  { label: 'Raporlar', icon: '📊', route: '/ik#raporlar', color: '#2e7d32' },
  { label: 'Ayarlar', icon: '⚙️', route: '/ik#ayarlar', color: '#6a1b9a' },
];

// ==== Bildirim tipinden emoji türet (fallback baslik ilk karakteri) ====
function bildirimEmojisi(b) {
  const t = (b && b.tip) || '';
  if (t === 'DOGUM_GUNU') return '🎂';
  if (t === 'DENEME_1AY' || t === 'DENEME_2AY') return '📋';
  if (t === 'BELGE_VADE') return '📄';
  if (t === 'IZIN_DONUSU') return '🔔';
  // Başlıktan emojiyi çek (varsa)
  const m = ((b && b.baslik) || '').match(/^[\p{Emoji}]/u);
  return (m && m[0]) || '🔔';
}

function borderRenk(vadeTarihi) {
  if (!vadeTarihi) return '#90a4ae';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const vade = new Date(vadeTarihi);
  const haftaSonra = new Date(today);
  haftaSonra.setDate(haftaSonra.getDate() + 7);
  if (vade < today) return '#c62828';      // gecikmiş — kırmızı
  if (vade <= haftaSonra) return '#f9a825'; // bu hafta — sarı
  return '#1565c0';                         // uzak — mavi
}

/**
 * İK Hatırlatmalar kartı — Dashboard içinde kullanılır.
 * 3 özet rozet + en yakın 10 bildirim + satır aksiyonları.
 */
const HatirlatmalarKarti = () => {
  const [ozet, setOzet] = useState({ bekleyen: 0, bu_hafta: 0, gecikmis: 0 });
  const [bildirimler, setBildirimler] = useState([]);
  const [loading, setLoading] = useState(true);

  const veriYukle = () => {
    fetch(`${API_URL}/api/hr/bildirimler/ozet`, { headers: headers() })
      .then(r => r.ok ? r.json() : { bekleyen: 0, bu_hafta: 0, gecikmis: 0 })
      .then(setOzet)
      .catch(() => {});
    fetch(`${API_URL}/api/hr/bildirimler?durum=BEKLIYOR&limit=10`, { headers: headers() })
      .then(r => r.ok ? r.json() : [])
      .then(d => { setBildirimler(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    veriYukle();
  }, []);

  const aksiyon = (b, yeniDurum) => {
    fetch(`${API_URL}/api/hr/bildirimler/${b.id}`, {
      method: 'PATCH',
      headers: { ...headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ durum: yeniDurum }),
    })
      .then(r => {
        if (r.ok) {
          setBildirimler(prev => prev.filter(x => x.id !== b.id));
          // Özet sayıları yenile
          fetch(`${API_URL}/api/hr/bildirimler/ozet`, { headers: headers() })
            .then(r => r.ok ? r.json() : null)
            .then(d => d && setOzet(d));
        }
      });
  };

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <h3 style={{ margin: 0, fontSize: 16, color: '#1a1a2e' }}>🔔 İK Hatırlatmaları</h3>
        <span
          style={{ fontSize: 11, color: '#90a4ae', cursor: 'not-allowed' }}
          title="Yakında: detaylı hatırlatma sayfası"
        >
          Tüm Hatırlatmaları Gör →
        </span>
      </div>

      {/* Özet rozetler */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 16 }}>
        <div style={{ background: '#e3f2fd', padding: 12, borderRadius: 8, borderLeft: '3px solid #1565c0' }}>
          <div style={{ fontSize: 11, color: '#555' }}>Bekleyen</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#1565c0' }}>{ozet.bekleyen}</div>
        </div>
        <div style={{ background: '#fff8e1', padding: 12, borderRadius: 8, borderLeft: '3px solid #f9a825' }}>
          <div style={{ fontSize: 11, color: '#555' }}>Bu Hafta</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#f9a825' }}>{ozet.bu_hafta}</div>
        </div>
        <div style={{ background: '#ffebee', padding: 12, borderRadius: 8, borderLeft: '3px solid #c62828' }}>
          <div style={{ fontSize: 11, color: '#555' }}>Gecikmiş</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#c62828' }}>{ozet.gecikmis}</div>
        </div>
      </div>

      {/* Liste */}
      {loading ? (
        <div style={{ color: '#888', padding: 12 }}>Yükleniyor...</div>
      ) : bildirimler.length === 0 ? (
        <div style={{ color: '#888', padding: 20, textAlign: 'center', fontSize: 12 }}>
          🎉 Bekleyen hatırlatma yok
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {bildirimler.map(b => {
            const renk = borderRenk(b.vade_tarihi);
            return (
              <div key={b.id} style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 6,
                border: '1px solid #eee', borderLeft: `4px solid ${renk}`,
                background: '#fafafa',
              }}>
                <div style={{ fontSize: 20 }}>{bildirimEmojisi(b)}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {b.baslik || b.tip}
                  </div>
                  <div style={{ fontSize: 11, color: '#666' }}>
                    {b.personel_ad || '—'} {b.vade_tarihi ? ` · ${b.vade_tarihi}` : ''}
                  </div>
                </div>
                <button
                  onClick={() => aksiyon(b, 'TAMAMLANDI')}
                  style={{ padding: '4px 10px', fontSize: 11, background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                >
                  ✓ Tamamlandı
                </button>
                <button
                  onClick={() => aksiyon(b, 'YOKSAYILDI')}
                  style={{ padding: '4px 10px', fontSize: 11, background: '#e0e0e0', color: '#555', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                >
                  Yoksay
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default function IkDashboard() {
  const { user } = useAuth();
  const [ozet, setOzet] = useState({ toplam: 0, aktif: 0, pasif: 0, izinli: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/personel`, { headers: headers() })
      .then(r => r.ok ? r.json() : [])
      .then(data => {
        const arr = Array.isArray(data) ? data : [];
        const aktif = arr.filter(p => p.aktif !== false).length;
        setOzet({
          toplam: arr.length,
          aktif,
          pasif: arr.length - aktif,
          izinli: 0,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Hatırlatmalar kartı sadece yonetim/ik rollerinde
  const hatirlatmaGorunsun = user && (user.role === 'ik' || user.role === 'yonetim' || user.role === 'admin');

  return (
    <div>
      <Header title="İnsan Kaynakları Panosu" />
      <div style={{ padding: 24, background: '#f5f5f5', minHeight: 'calc(100vh - 60px)' }}>
        {/* KPI Kartları */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 24 }}>
          {[
            { label: 'Toplam Personel', value: loading ? '...' : ozet.toplam, color: '#1565c0', icon: '👥' },
            { label: 'Aktif', value: loading ? '...' : ozet.aktif, color: '#2e7d32', icon: '✅' },
            { label: 'Pasif', value: loading ? '...' : ozet.pasif, color: '#616161', icon: '⏸️' },
          ].map(k => (
            <div key={k.label} style={{
              background: '#fff', borderRadius: 12, padding: 20,
              borderLeft: `4px solid ${k.color}`, boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>{k.icon} {k.label}</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: k.color }}>{k.value}</div>
            </div>
          ))}
        </div>

        {/* İK Hatırlatmaları */}
        {hatirlatmaGorunsun && <HatirlatmalarKarti />}

        {/* Hızlı Erişim */}
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, color: '#1a1a2e' }}>Hızlı Erişim</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
            {KART_TIPLERI.map(item => (
              <div
                key={item.label}
                onClick={() => window.location.href = item.route}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: '18px 16px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  border: `1px solid #eee`,
                  borderLeft: `4px solid ${item.color}`,
                  transition: 'transform 0.15s, box-shadow 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{ fontSize: 26, marginBottom: 6 }}>{item.icon}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: item.color }}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
